import React, { ReactNode } from "react";

// A table cell in content data (blog posts, grammar points): plain text, or a
// list of parts where `{ strong }` marks the piece to emphasise - used to
// highlight the one kana that moves between verb forms (売 + ら, り, る, れ, ろ).
export type TableCellPart = string | { strong: string };
export type TableCellValue = string | TableCellPart[];

// Lets a caller (e.g. blog posts, to make Japanese runs saveable) render each
// piece of cell text through its own wrapper instead of plain text. Callers
// that don't need this (e.g. GrammarDetailPage) get the previous behaviour.
export type TableCellTextRenderer = (text: string, key: React.Key) => ReactNode;

const renderPlainText: TableCellTextRenderer = (text, key) => <React.Fragment key={key}>{text}</React.Fragment>;

export function tableCellText(cell: TableCellValue): string {
    if (typeof cell === "string") return cell;
    return cell.map((part) => (typeof part === "string" ? part : part.strong)).join("");
}

export default function TableCell({ cell, renderText = renderPlainText }: { cell: TableCellValue; renderText?: TableCellTextRenderer }) {
    if (typeof cell === "string") return <>{renderText(cell, "text")}</>;
    return (
        <>
            {cell.map((part, index) =>
                typeof part === "string" ? (
                    renderText(part, index)
                ) : (
                    <strong key={index}>{renderText(part.strong, index)}</strong>
                )
            )}
        </>
    );
}
